module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/linux-b2f848aa7cfd3013c4ece8aa8bd9ec58.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/linux.svg
// module id = O2Hr
// module chunks = 24